export default "__VITE_ASSET__032f85f2__"